<template>
    <div>
        <div class="row">
            <div class="col-md-7">
                <div class="row">
                    <div class="col-md-6 py_5px">
                        <div class="label_box">
                            <img
                                style="height: 90px"
                                src="../../../assets/rb_44645.png"
                            />
                            <div style="padding-left: 1rem; width: 100%">
                                <p>ยอดขายสินค้า</p>
                                <h2 class="text_data">
                                    <!-- {{ amount }} บาท -->
                                    <!-- {{ purchaseNum }} ชิ้น {{ purchaseAmount }} บาท -->
                                    {{ totalItemsInTable }} ชิ้น {{ totalAmountInTable }} บาท
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-6 py_5px">
                        <div class="label_box">
                            <img
                                style="height: 90px"
                                src="../../../assets/rb_44646.png"
                            />
                            <div style="padding-left: 1rem; width: 100%">
                                <p>ยอดสั่งจองสินค้า</p>
                                <h2 class="text_data">
                                    {{ num }} ชิ้น {{ preorderAmount }} บาท
                                </h2>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-12 py_5px">
                        <div class="chart">
                            <h3 style="margin-bottom: 10px; margin-top: 20px">
                                ยอดขายแยกตามผลิตภัณฑ์ (บาท)
                            </h3>
                            <highcharts
                                style="height: 600px"
                                :options="chartOptions"
                            ></highcharts>
                        </div>
                    </div>
                </div>
            </div>
            <div class="col-md-5">
                <!-- Pie Chart Section -->
                <div class="chart" style="margin-bottom: 10px; margin-top: 0">
                    <h3 style="margin-bottom: 10px">
                        สัดส่วนยอดขายแยกตามประเภทของผลิตภัณฑ์
                    </h3>
                    <highcharts
                        style="height: 280px"
                        :options="pieOption"
                    ></highcharts>
                </div>
                <div class="chart" style="margin-top: 0">
                    <div style="display: flex; gap: 10px; margin-bottom: 10px">
                        <div
                            :class="
                                activeTab === 'sales'
                                    ? 'tab_active'
                                    : 'tab_notactive'
                            "
                            @click="activeTab = 'sales'"
                            style="
                                cursor: pointer;
                                padding: 8px 16px;
                                border-radius: 4px;
                            "
                        >
                            รายการขายผลิตภัณฑ์
                        </div>
                        <div
                            :class="
                                activeTab === 'preorders'
                                    ? 'tab_active'
                                    : 'tab_notactive'
                            "
                            @click="activeTab = 'preorders'"
                            style="
                                cursor: pointer;
                                padding: 8px 16px;
                                border-radius: 4px;
                            "
                        >
                            รายการจองผลิตภัณฑ์
                        </div>
                    </div>
                    <h3
                        v-if="activeTab === 'sales'"
                        style="margin-bottom: 10px"
                    >
                        รายการขายผลิตภัณฑ์
                    </h3>
                    <h3 v-else style="margin-bottom: 10px">
                        รายการจองผลิตภัณฑ์
                    </h3>
                    <div v-if="activeTab === 'sales'" class="table-container">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>ชุมชน</th>
                                    <th>ผลิตภัณฑ์</th>
                                    <th>ราคา</th>
                                    <th>จํานวน</th>
                                    <th>ยอดขาย (บาท)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr
                                    v-for="(item, index) in tableData"
                                    :key="index"
                                >
                                    <td>{{ item.community }}</td>
                                    <td>{{ item.product }}</td>
                                    <td>
                                        {{
                                            (
                                                item.sales / item.quantity
                                            ).toLocaleString()
                                        }}
                                    </td>
                                    <td>{{ item.quantity }}</td>
                                    <td>{{ item.sales.toLocaleString() }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div v-else class="table-container">
                        <table class="table table-striped">
                            <thead>
                                <tr>
                                    <th>ชุมชน</th>
                                    <th>ผลิตภัณฑ์</th>
                                    <th>ราคา</th>
                                    <th>จํานวน</th>
                                    <th>ยอดขาย (บาท)</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-if="preordersLoading">
                                    <td colspan="5" style="text-align: center">
                                        กำลังโหลด...
                                    </td>
                                </tr>
                                <tr v-else-if="preordersData.length === 0">
                                    <td colspan="5" style="text-align: center">
                                        ไม่พบข้อมูลรายการจอง
                                    </td>
                                </tr>
                                <tr
                                    v-else
                                    v-for="(item, index) in preordersData"
                                    :key="index"
                                >
                                    <td>{{ item.community }}</td>
                                    <td>{{ item.product_name }}</td>
                                    <td>{{ formatMoney(item.unit_price) }}</td>
                                    <td>{{ item.quantity }}</td>
                                    <td>{{ formatMoney(item.total_price) }}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Highcharts from "highcharts";
import HighchartsVue from "highcharts-vue";
import axios from "axios";

Highcharts.setOptions({
    lang: {
        decimalPoint: ".",
        thousandsSep: ",",
    },
});
export default {
    name: "ColumnChart",
    components: {
        highcharts: HighchartsVue.component,
    },
    data() {
        return {
            activeTab: "sales",
            tableData: [],
            preordersData: [],
            preordersLoading: false,
            chartOptions: {
                chart: {
                    type: "column",
                },
                title: {
                    text: "",
                },
                xAxis: {
                    type: "category",
                    labels: {
                        autoRotation: [-45, -90],
                    },
                },
                yAxis: {
                    min: 0,
                    title: {
                        text: "ยอดขาย (บาท)",
                    },
                },
                legend: {
                    enabled: true,
                },
                tooltip: {
                    shared: true,
                    formatter: function () {
                        let s = "<b>" + this.x + "</b>";
                        this.points.forEach(function (point) {
                            s +=
                                "<br/>" +
                                point.series.name +
                                ": " +
                                point.y.toLocaleString() +
                                " บาท";
                        });
                        return s;
                    },
                },
                plotOptions: {
                    column: {
                        dataLabels: {
                            enabled: true,
                            formatter: function () {
                                return this.y?.toLocaleString();
                            },
                        },
                    },
                },
                series: [
                    {
                        name: "ขาย",
                        color: "#206ab0",
                        data: [],
                    },
                    {
                        name: "จอง",
                        color: "#FFB200",
                        data: [],
                    },
                ],
                exporting: {
                    enabled: false,
                },
                credits: {
                    enabled: false,
                },
            },

            pieOption: {
                chart: {
                    type: "pie",
                },
                title: {
                    text: "",
                },
                tooltip: {
                    pointFormat:
                        "{series.name}: <b>{point.y} บาท </b> <br/> คิดเป็น: <b>{point.percentage:.1f}%</b>",
                },
                plotOptions: {
                    series: {
                        allowPointSelect: true,
                        cursor: "pointer",
                    },
                    pie: {
                        showInLegend: true,
                    },
                },
                series: [
                    {
                        name: "ยอดขาย",
                        colors: [
                            "#EB5B00",
                            "#FFB200",
                            "#B60071",
                            "#FF4C4C",
                            "#FFB22C",
                            "#FFDE4D",
                            "#FFAD60",
                            "#FFBF78",
                            "#FEB941",
                        ],
                        colorByPoint: true,
                        data: [],
                    },
                ],
                exporting: {
                    enabled: false,
                },
                credits: {
                    enabled: false,
                },
            },
            amount: "0",
            num: "0",
            preorderAmount: "0",
            purchaseNum: "0",
            purchaseAmount: "0",
        };
    },
    
    computed: {
        totalItemsInTable() {
            const total = this.tableData.reduce((sum, item) => {
                // ป้องกัน string concatenation แทน addition
                return sum + (parseInt(item.quantity) || 0);
            }, 0);
            return total.toLocaleString();
        },
        totalAmountInTable() {
            const total = this.tableData.reduce((sum, item) => {
                return sum + (parseFloat(item.sales) || 0);
            }, 0);
            return total.toLocaleString();
        }
    },
    mounted() {
        this.fetchData();
    },
    watch: {
        activeTab(newTab) {
            if (newTab === "preorders" && this.preordersData.length === 0) {
                this.fetchPreordersData();
            }
        },
    },
    methods: {
        /*
        async fetchData() {
            try {
                const community_id = localStorage.getItem("community_id");
                const role_id = localStorage.getItem("role_id");
                const apiData = [];
                if (role_id == 1) {
                    const res = await axios.get(
                        "https://openapi.kims-rmuti.com/api/ProductCommition",
                    );
                    apiData.push(...res.data);
                } else {
                    const res = await axios.get(
                        `https://openapi.kims-rmuti.com/api/ProductCommition?community=${community_id}`,
                    );
                    apiData.push(...res.data);
                }
                this.tableData = apiData.map((item) => ({
                    community: item.community_name || "ไม่ระบุ",
                    product: item.product_name || "ไม่ระบุ",
                    quantity: item.product_quantity_sum || 0,
                    sales: parseInt(item.total_price_sum) || 0,
                }));

                // Fetch preorders for charts
                const preordersRes = await axios.get(
                    // "https://center-data.rcbt-sip.com/api/preorders",
                    "https://api.xn--42cf1c1az5dtau6v.com/api/preorders",
                );
                let preorders = Array.isArray(preordersRes?.data)
                    ? preordersRes.data
                    : preordersRes?.data?.data || [];

                preorders = preorders.filter((item) => item?.order_type === "preorder");

                // Filter by community_id for non-admin users
                if (
                    role_id != 1 &&
                    community_id &&
                    community_id !== "null" &&
                    community_id !== "undefined"
                ) {
                    const commId = parseInt(community_id);
                    preorders = preorders.filter((item) => {
                        const topLevelComm = parseInt(item?.community_id);
                        if (!isNaN(topLevelComm))
                            return topLevelComm === commId;
                        const productComm = parseInt(
                            item?.product_community?.community_id,
                        );
                        if (!isNaN(productComm)) return productComm === commId;
                        try {
                            const epd = item?.external_product_data
                                ? JSON.parse(item.external_product_data)
                                : null;
                            const extComm = parseInt(
                                epd?.external_data?.community_id ||
                                    epd?.community_id,
                            );
                            if (!isNaN(extComm)) return extComm === commId;
                        } catch (_) {
                            return false;
                        }
                        return false;
                    });
                }
                

                // Process preorders for charts
                const preordersByProduct = {};
                const preordersByGroup = {};
                let total_num = 0;
                let total_amount = 0;

                preorders.forEach((item) => {
                    const qty = parseInt(item?.quantity) || 0;
                    const price = parseFloat(item?.total_price) || 0;
                    total_num += qty;
                    total_amount += price;

                    // Parse product info
                    let product_name = "ไม่ระบุ";
                    let product_group = "ไม่ระบุ";

                    try {
                        if (item?.external_product_data) {
                            const epd = JSON.parse(item.external_product_data);
                            product_name =
                                epd?.name ||
                                epd?.external_data?.product_name ||
                                product_name;
                            product_group =
                                epd?.external_data?.product_group_name ||
                                product_group;
                        }
                    } catch (_) {
                        void 0;
                    }

                    // Group by product
                    if (!preordersByProduct[product_name]) {
                        preordersByProduct[product_name] = 0;
                    }
                    preordersByProduct[product_name] += price;

                    // Group by category
                    if (!preordersByGroup[product_group]) {
                        preordersByGroup[product_group] = 0;
                    }
                    preordersByGroup[product_group] += price;
                });

                this.num = total_num?.toLocaleString();
                this.preorderAmount = total_amount?.toLocaleString();

                // Combine sales and preorders for pie chart (by category)
                const combinedGroupData = {};
                apiData.forEach((item) => {
                    const groupName = item.product_group_name || "ไม่ระบุ";
                    const price = parseInt(item.total_price_sum) || 0;
                    if (!combinedGroupData[groupName]) {
                        combinedGroupData[groupName] = {
                            name: groupName,
                            y: 0,
                        };
                    }
                    combinedGroupData[groupName].y += price;
                });

                Object.keys(preordersByGroup).forEach((groupName) => {
                    if (!combinedGroupData[groupName]) {
                        combinedGroupData[groupName] = {
                            name: groupName,
                            y: 0,
                        };
                    }
                    combinedGroupData[groupName].y +=
                        preordersByGroup[groupName];
                });

                this.pieOption.series[0].data =
                    Object.values(combinedGroupData);

                // Combine sales and preorders for column chart (by product)
                const salesByProduct = {};
                apiData.forEach((item) => {
                    const productName = item.product_name || "ไม่ระบุ";
                    salesByProduct[productName] =
                        parseInt(item.total_price_sum) || 0;
                });

                // Get all unique product names
                const allProducts = new Set([
                    ...Object.keys(salesByProduct),
                    ...Object.keys(preordersByProduct),
                ]);

                const categories = Array.from(allProducts);
                const salesData = categories.map(
                    (product) => salesByProduct[product] || 0,
                );
                const preordersData = categories.map(
                    (product) => preordersByProduct[product] || 0,
                );

                this.chartOptions.xAxis.categories = categories;
                this.chartOptions.series[0].data = salesData;
                this.chartOptions.series[1].data = preordersData;

                let total = 0;
                apiData.forEach((item) => {
                    total += parseInt(item.total_price_sum) || 0;
                });
                this.amount = total?.toLocaleString();
            } catch (error) {
                console.error("Error fetching chart data:", error);
            }
        },
        */
       async fetchData() {
            try {
                const community_id = localStorage.getItem("community_id");
                const role_id = localStorage.getItem("role_id");
                const apiData = [];
                
                // Fetch ProductCommition data
                if (role_id == 1) {
                    const res = await axios.get(
                        "https://openapi.kims-rmuti.com/api/ProductCommition",
                    );
                    apiData.push(...res.data);
                } else {
                    const res = await axios.get(
                        `https://openapi.kims-rmuti.com/api/ProductCommition?community=${community_id}`,
                    );
                    apiData.push(...res.data);
                }
                
                // this.tableData = apiData.map((item) => ({
                //     community: item.community_name || "ไม่ระบุ",
                //     product: item.product_name || "ไม่ระบุ",
                //     quantity: item.product_quantity_sum || 0,
                //     sales: parseInt(item.total_price_sum) || 0,
                // }));

                // Fetch all orders (both preorder and purchase)
                const ordersRes = await axios.get(
                    "https://api.xn--42cf1c1az5dtau6v.com/api/preorders",
                );
                let allOrders = Array.isArray(ordersRes?.data)
                    ? ordersRes.data
                    : ordersRes?.data?.data || [];

                // Split orders by type
                let preorders = allOrders.filter((item) => item?.order_type === "preorder");
                let purchases = allOrders.filter((item) => item?.order_type === "purchase");

                // Filter by community_id for non-admin users
                if (
                    role_id != 1 &&
                    community_id &&
                    community_id !== "null" &&
                    community_id !== "undefined"
                ) {
                    const commId = parseInt(community_id);
                    const filterByCommunity = (item) => {
                        const topLevelComm = parseInt(item?.community_id);
                        if (!isNaN(topLevelComm))
                            return topLevelComm === commId;
                        const productComm = parseInt(
                            item?.product_community?.community_id,
                        );
                        if (!isNaN(productComm)) return productComm === commId;
                        try {
                            const epd = item?.external_product_data
                                ? JSON.parse(item.external_product_data)
                                : null;
                            const extComm = parseInt(
                                epd?.external_data?.community_id ||
                                    epd?.community_id,
                            );
                            if (!isNaN(extComm)) return extComm === commId;
                        } catch (_) {
                            return false;
                        }
                        return false;
                    };
                    
                    preorders = preorders.filter(filterByCommunity);
                    purchases = purchases.filter(filterByCommunity);
                }

                // Table ppurchase order for table
                const tableDataFromCommition = apiData.map((item) => ({
                    community: item.community_name || "ไม่ระบุ",
                    product: item.product_name || "ไม่ระบุ",
                    quantity: item.product_quantity_sum || 0,
                    sales: parseInt(item.total_price_sum) || 0,
                    source: "commission"
                }));

                // Process purchase orders for table
                const tableDataFromPurchases = purchases.map((item) => {
                    let product_name = "ไม่ระบุ";
                    let community_name = "ไม่ระบุ";
                    try {
                        if (item?.external_product_data) {
                            const epd = JSON.parse(item.external_product_data);
                            product_name =
                                epd?.name ||
                                epd?.external_data?.product_name ||
                                product_name;
                            community_name =
                                epd?.community_name ||
                                epd?.external_data?.community_name ||
                                "ไม่ระบุ";
                        }
                        if (item?.product_community?.community_name) {
                            community_name = item.product_community.community_name;
                        }
                    } catch (_) {
                        void 0;
                    }

                    return {
                        community: community_name,
                        product: product_name,
                        quantity: parseInt(item?.quantity) || 0,
                        sales: parseFloat(item?.total_price) || 0,
                        source: "purchase"
                    };
                });

                this.tableData = [...tableDataFromCommition, ...tableDataFromPurchases];


                // Process preorders for charts and summary
                const preordersByProduct = {};
                const preordersByGroup = {};
                let total_num = 0;
                let total_amount = 0;

                preorders.forEach((item) => {
                    const qty = parseInt(item?.quantity) || 0;
                    const price = parseFloat(item?.total_price) || 0;
                    total_num += qty;
                    total_amount += price;

                    // Parse product info
                    let product_name = "ไม่ระบุ";
                    let product_group = "ไม่ระบุ";

                    try {
                        if (item?.external_product_data) {
                            const epd = JSON.parse(item.external_product_data);
                            product_name =
                                epd?.name ||
                                epd?.external_data?.product_name ||
                                product_name;
                            product_group =
                                epd?.external_data?.product_group_name ||
                                product_group;
                        }
                    } catch (_) {
                        void 0;
                    }

                    // Group by product
                    if (!preordersByProduct[product_name]) {
                        preordersByProduct[product_name] = 0;
                    }
                    preordersByProduct[product_name] += price;

                    // Group by category
                    if (!preordersByGroup[product_group]) {
                        preordersByGroup[product_group] = 0;
                    }
                    preordersByGroup[product_group] += price;
                });

                this.num = total_num?.toLocaleString();
                this.preorderAmount = total_amount?.toLocaleString();

                // Process purchases for sales calculation
                const purchasesByProduct = {};
                const purchasesByGroup = {};
                let purchase_total_amount = 0;
                let purchase_total_num = 0;

                purchases.forEach((item) => {
                    const qty = parseInt(item?.quantity) || 0;
                    const price = parseFloat(item?.total_price) || 0;
                    purchase_total_amount += price;
                    purchase_total_num += qty;

                    // Parse product info
                    let product_name = "ไม่ระบุ";
                    let product_group = "ไม่ระบุ";

                    try {
                        if (item?.external_product_data) {
                            const epd = JSON.parse(item.external_product_data);
                            product_name =
                                epd?.name ||
                                epd?.external_data?.product_name ||
                                product_name;
                            product_group =
                                epd?.external_data?.product_group_name ||
                                product_group;
                        }
                    } catch (_) {
                        void 0;
                    }

                    // Group by product
                    if (!purchasesByProduct[product_name]) {
                        purchasesByProduct[product_name] = 0;
                    }
                    purchasesByProduct[product_name] += price;

                    // Group by category
                    if (!purchasesByGroup[product_group]) {
                        purchasesByGroup[product_group] = 0;
                    }
                    purchasesByGroup[product_group] += price;
                });

                // Calculate total sales (ProductCommition + purchases)
                let commission_total = 0;
                apiData.forEach((item) => {
                    commission_total += parseInt(item.total_price_sum) || 0;
                });
                
                const total_sales = commission_total + purchase_total_amount;
                this.amount = total_sales?.toLocaleString();
                
                this.purchaseNum = purchase_total_num?.toLocaleString();
                this.purchaseAmount = purchase_total_amount?.toLocaleString();

                // Combine all data for pie chart (by category)
                const combinedGroupData = {};
                
                // Add ProductCommition data
                apiData.forEach((item) => {
                    const groupName = item.product_group_name || "ไม่ระบุ";
                    const price = parseInt(item.total_price_sum) || 0;
                    if (!combinedGroupData[groupName]) {
                        combinedGroupData[groupName] = {
                            name: groupName,
                            y: 0,
                        };
                    }
                    combinedGroupData[groupName].y += price;
                });

                // Add purchases data
                Object.keys(purchasesByGroup).forEach((groupName) => {
                    if (!combinedGroupData[groupName]) {
                        combinedGroupData[groupName] = {
                            name: groupName,
                            y: 0,
                        };
                    }
                    combinedGroupData[groupName].y += purchasesByGroup[groupName];
                });

                // Add preorders data
                Object.keys(preordersByGroup).forEach((groupName) => {
                    if (!combinedGroupData[groupName]) {
                        combinedGroupData[groupName] = {
                            name: groupName,
                            y: 0,
                        };
                    }
                    combinedGroupData[groupName].y += preordersByGroup[groupName];
                });

                this.pieOption.series[0].data = Object.values(combinedGroupData);

                // Combine sales and preorders for column chart (by product)
                const salesByProduct = {};
                
                // Add ProductCommition data
                apiData.forEach((item) => {
                    const productName = item.product_name || "ไม่ระบุ";
                    salesByProduct[productName] = parseInt(item.total_price_sum) || 0;
                });

                // Add purchases data to sales
                Object.keys(purchasesByProduct).forEach((productName) => {
                    if (!salesByProduct[productName]) {
                        salesByProduct[productName] = 0;
                    }
                    salesByProduct[productName] += purchasesByProduct[productName];
                });

                // Get all unique product names
                const allProducts = new Set([
                    ...Object.keys(salesByProduct),
                    ...Object.keys(preordersByProduct),
                ]);

                const categories = Array.from(allProducts);
                const salesData = categories.map(
                    (product) => salesByProduct[product] || 0,
                );
                const preordersData = categories.map(
                    (product) => preordersByProduct[product] || 0,
                );

                this.chartOptions.xAxis.categories = categories;
                this.chartOptions.series[0].data = salesData;
                this.chartOptions.series[1].data = preordersData;

            } catch (error) {
                console.error("Error fetching chart data:", error);
            }
        },
        calculatePercentage(value) {
            const total = this.pieOption.series[0].data.reduce(
                (sum, item) => sum + item.y,
                0,
            );
            return (value / total) * 100;
        },
        async fetchPreordersData() {
            this.preordersLoading = true;
            try {
                const res = await axios.get(
                    // "https://center-data.rcbt-sip.com/api/preorders",
                    "https://api.xn--42cf1c1az5dtau6v.com/api/preorders",
                );
                let raw = Array.isArray(res?.data)
                    ? res.data
                    : res?.data?.data || [];

                raw = raw.filter((item) => item?.order_type === "preorder");

                const community_id = localStorage.getItem("community_id");
                const role_id = localStorage.getItem("role_id");

                // Filter by community_id for non-admin users
                if (
                    role_id != 1 &&
                    community_id &&
                    community_id !== "null" &&
                    community_id !== "undefined"
                ) {
                    const commId = parseInt(community_id);
                    raw = raw.filter((item) => {
                        const topLevelComm = parseInt(item?.community_id);
                        if (!isNaN(topLevelComm))
                            return topLevelComm === commId;
                        const productComm = parseInt(
                            item?.product_community?.community_id,
                        );
                        if (!isNaN(productComm)) return productComm === commId;
                        try {
                            const epd = item?.external_product_data
                                ? JSON.parse(item.external_product_data)
                                : null;
                            const extComm = parseInt(
                                epd?.external_data?.community_id ||
                                    epd?.community_id,
                            );
                            if (!isNaN(extComm)) return extComm === commId;
                        } catch (_) {
                            return false;
                        }
                        return false;
                    });
                }

                this.preordersData = raw.map((item) => {
                    let product_name = "ไม่ระบุ";
                    let community_name = "-";
                    try {
                        if (item?.external_product_data) {
                            const epd = JSON.parse(item.external_product_data);
                            product_name =
                                epd?.name ||
                                epd?.external_data?.product_name ||
                                product_name;
                            community_name =
                                epd?.community_name ||
                                epd?.external_data?.community_name ||
                                "-";
                        }
                        if (item?.product_community?.community_name) {
                            community_name =
                                item.product_community.community_name;
                        }
                    } catch (_) {
                        void 0;
                    }
                    return {
                        community: community_name,
                        product_name,
                        quantity: parseInt(item?.quantity) || 0,
                        unit_price: parseFloat(item?.unit_price) || 0,
                        total_price: parseFloat(item?.total_price) || 0,
                    };
                });
            } catch (e) {
                console.error("Error fetching preorders:", e);
                this.preordersData = [];
            } finally {
                this.preordersLoading = false;
            }
        },
        formatMoney(value) {
            const num = parseFloat(value);
            return isNaN(num)
                ? "0"
                : new Intl.NumberFormat(undefined, {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2,
                  }).format(num);
        },
        mapPaymentStatus(status) {
            if (!status) return "-";
            const map = {
                paid: "ชำระแล้ว",
                unpaid: "ยังไม่ชำระ",
                pending: "รอตรวจสอบ",
            };
            return map[status] || status;
        },
    },
};
</script>

<style scoped>
.top-banner {
    position: relative;
    background-color: #f9f9f9;
    padding: 40px;
}
.line_blue {
    margin-top: 13px !important;
    margin-bottom: 20px !important;
    border: 0 !important;
    border-top: 2px solid #206ab0 !important;
}
h3 {
    font-size: 20px;
    font-weight: 500;
    text-align: start;
}

.text_data {
    margin-top: 1rem;
    font-size: 34px;
    font-weight: 600;
    text-align: center;
}

.label_box {
    display: flex;
    background-color: #ffffff;
    padding: 25px 25px 25px 25px;
    border-radius: 5px;
    border: 1px solid #e3e3e3;
    box-shadow: 1px 1px 5px #e3e3e3;
}
.label_box p {
    font-size: 16px;
}

.chart {
    margin-top: 10px;
    padding: 20px;
    background-color: #ffffff;
    border-radius: 5px;
    box-shadow: 1px 1px 5px #e3e3e3;
}

.py_5px {
    padding-left: 5px !important;
    padding-right: 5px !important;
}

.table-container {
    max-height: 400px;
    overflow: auto;
    border: 1px solid #ddd;
    border-radius: 5px;
}
.table {
    margin: 0;
    width: 100%;
}

.table th {
    white-space: nowrap;
    text-align: left;
    font-size: 16px;
    font-weight: bold;
}

.tab_active {
    background-color: #206ab0;
    color: white;
    font-weight: 500;
}

.tab_notactive {
    background-color: #f0f0f0;
    color: #333;
    font-weight: 400;
}
</style>
